import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Mountain } from "lucide-react";
import { api } from "@/lib/api";

export default function LoginPage() {
  const nav = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me", { withCredentials: true })
      .then(() => nav("/admin/filings", { replace: true }))
      .catch(() => setChecking(false));
  }, [nav]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/filings";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) return <div className="bb-container py-20 text-center bb-overline text-bb-slate">Checking session…</div>;

  return (
    <section className="bb-container py-20" data-testid="login-page">
      <div className="max-w-md mx-auto bg-white border border-border p-8 lg:p-10">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-bb-navy text-white mb-6">
          <Mountain size={22} strokeWidth={2.2} />
        </div>
        <div className="bb-overline text-bb-copper">Editorial · Admin</div>
        <h1 className="font-archivo text-3xl text-bb-navy font-bold mt-3">Sign in to BedrockBulletin</h1>
        <p className="text-sm text-bb-slate mt-3 leading-relaxed">
          Access is restricted to allowlisted editors. Sign in with your Google account to reach the editorial dashboard.
        </p>
        <button
          type="button"
          onClick={signIn}
          data-testid="login-google-btn"
          className="bb-btn-primary inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm mt-8 w-full"
        >
          <LogIn size={16} strokeWidth={2.2} />
          Continue with Google
        </button>
        <p className="mt-5 text-[11px] font-mono text-bb-slate leading-relaxed">
          Not on the allowlist? You&rsquo;ll be redirected back with a 403 message.
        </p>
      </div>
    </section>
  );
}
